import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import toast from './modules/toast';
import token from './modules/token';
import user from './modules/user';
import header from './modules/header';
import modal from './modules/modal';
import nativeFileSelect from './modules/nativeFileSelect';

export default createStore({
	state: {
		scrollDirection: 0,
	},
	getters: {},
	mutations: {
		setScrollInfo(state, { scrollDirection }) {
			if (scrollDirection !== undefined) state.scrollDirection = scrollDirection;
		},
	},
	actions: {},
	modules: {
		toast,
		token,
		user,
		header,
		modal,
		nativeFileSelect,
	},
	plugins: [
		createPersistedState({
			key: ['token'],
			paths: ['token'],
		}),
		createPersistedState({
			key: ['user'],
			paths: ['user'],
		}),
	],
});
